"use client"

import type React from "react"
import { usePathname } from "next/navigation"
import { estRouteTunnelDeclic } from "@/lib/declic/routes"

/** N'affiche ses enfants (navigation tuteur.ai) qu'en dehors du tunnel DÉCLIC /inscription*. */
export function HorsTunnelDeclic({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  if (estRouteTunnelDeclic(pathname)) return null
  return <>{children}</>
}
